export default "__VITE_ASSET__815b2c51__"